<template>
  <div>
    <el-link
      type="info"
      :loading="isLoading"
      class="mr-1"
      @click="downloadFile"
    >
      {{ attachment.path }}
    </el-link>
  </div>
</template>
<script lang="ts">

import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { GetTicketAttachmentUrlQuery, TicketAttachment } from '@/types/graphql'

@Component({
  components: {
  }
})
export default class extends Vue {
    @Prop({ required: true }) private attachment!: TicketAttachment
    private isLoading=false;

    downloadFile() {
      this.isLoading = true
      this.$apollo.query({
        query: GetTicketAttachmentUrlQuery,
        variables: {
          attachmentID: this.attachment.id,
          fileName: this.attachment.path
        }
      }).then(res => {
        window.open(res.data.getTicketAttachmentURL)
      })
        .finally(() => {
          this.isLoading = false
        })
    }
}
</script>
<style scoped>
.el-link{
  font-size: .8rem;
  font-style: normal;
}
</style>
